var _path, _path2, _path3, _circle, _circle2, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainsTwoForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M32.8 28.5c1.7-.5 2.9-2.1 2.9-4V9c0-2.3-1.9-4.2-4.2-4.2H20.4c-1.1 0-2.1.4-2.8 1.1M22.4 24.5h-10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.4 11.3h12.3c2.6 0 4.6 2.1 4.6 4.6V33c0 2.6-2.1 4.6-4.6 4.6H11.4c-2.6 0-4.6-2.1-4.6-4.6V15.9c0-2.5 2.1-4.6 4.6-4.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M17.7 11.3v5.6M23.6 11.3v5.6M11.7 11.3v5.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 17.7,
    cy: 17.7,
    r: 1.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 11.7,
    cy: 17.7,
    r: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 23.6,
    cy: 17.7,
    r: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M12.4 29.7h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainsTwoForms);
export default __webpack_public_path__ + "static/media/containsTwoForms.67fb27548c3687c144dd3ecaa128cdf9.svg";
export { ForwardRef as ReactComponent };